import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Login from '@/views/login'
import Sign from '@/views/Sign'
import Education from '@/views/education'
import EducationDetail from '@/views/EducationDetail'
import Recruit from '@/views/recruit'
import Detail from '@/views/detail'
import Publish from '@/views/publish/publish'
import Car from '@/views/publish/publishItem/car'
import Pet from '@/views/publish/publishItem/Pet'
import pet from '@/views/Pet'
import Home from '@/views/publish/publishItem/Home'
import SecondHand from '@/views/publish/publishItem/secondHand'
import News from '@/views/news'
import AboutUs from '@/views/aboutUs'
import ConnectUs from '@/views/connectUs'
import Friend from '@/views/publish/publishItem/friend'
import Live from '@/views/publish/publishItem/live'
import Parttime from '@/views/publish/publishItem/part_time'
import Resume from '@/views/publish/publishItem/resume'
import Edu from '@/views/publish/publishItem/edu'
import RecruitPublish from '@/views/publish/publishItem/recruit'
import Category from '@/views/category'
import More from '@/views/morenews'


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/sign',
      name: 'sign',
      component: Sign
    },
    {
      path: '/education',
      name: 'education',
      component: Education
    },
    {
      path: '/educationDetail',
      name: 'educationDetail',
      component: EducationDetail
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit
    },
    {
      path: '/pet',
      name: 'petlist',
      component: pet
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
    {
      path: '/publish',
      name: 'publish',
      component: Publish,
    },
    {
      path: '/homePublish',
      name: 'homePublish',
      component: Home
    },
    {
      path: '/carPublish',
      name: 'carPublish',
      component: Car
    },
    {
      path: '/petPublish',
      name: 'petPublish',
      component: Pet
    },
    {
      path: '/secondhandPublish',
      name: 'secondHandPublish',
      component: SecondHand
    },
    {
      path: '/friendPublish',
      name: 'friendPublish',
      component: Friend
    },
    {
      path: '/livePublish',
      name: 'livePublish',
      component: Live
    },
    {
      path: '/eduPublish',
      name: 'edupublish',
      component: Edu
    },
    {
      path: '/recruitPublish',
      name: 'recruitpublish',
      component: RecruitPublish
    },
    {
      path: '/partTimePublish',
      name: 'partTimePublish',
      component: Parttime
    },
    {
      path: '/resumePublish',
      name: 'resumePublish',
      component: Resume
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/connectUs',
      name: 'connectUs',
      component: ConnectUs
    }, {
      path: '/category',
      name: 'category',
      component: Category
    },
    {
      path: '/more',
      name: 'morenews',
      component: More
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js